import { withTranslation } from 'react-i18next';
import { reduxForm } from 'redux-form';

import { FORM_NAMES } from 'constants/forms';
import validate from './validate';
import AddPatient from './AddPatient';

export const AddPatientContainer = reduxForm({
  form: FORM_NAMES.addPatient,
  validate,
  initialValues: {
    patientPhone: [null],
    caregiverPhone: [null],
    alternatePhone: [null],
  },
})(AddPatient);

export default withTranslation()(AddPatientContainer);
